import router from '../router';
const state = {
    contactBeingEdited: ''
};

const getters = {
	
};

const mutations = {
	setContactBeingEdited(state, contact) {
        state.contactBeingEdited = contact
        console.log(state.contactBeingEdited)
    },
};

const actions = {
	setContactBeingEdited({commit}, contact) {
        commit('setContactBeingEdited', contact)
    },
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};